/* global __CI_APP__, __CI_BUILD__, __SDK_VERSION__, __CI_CONFIG__ */
import { useEffect } from 'react'
import * as Sentry from '@sentry/react'
import { createRoutesFromChildren, matchRoutes, useLocation, useNavigationType } from 'react-router-dom'

const isProduction = process.env.NODE_ENV === 'production'
const mode = isProduction ? 'production' : 'develop'
const traceRate = isProduction ? 0.25 : 1.0
const localBuildId = 'local'

export const sentryFeedback = Sentry.feedbackIntegration({
  colorScheme: 'system',
  isNameRequired: true,
  isEmailRequired: true,
  autoInject: false // Prevents auto-rendering on page load
})

if (process.env.SENTRY_ENABLE === 'true') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [
      sentryFeedback,
      Sentry.extraErrorDataIntegration(),
      Sentry.captureConsoleIntegration(),
      Sentry.browserSessionIntegration(),
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration(),
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      })
    ],
    tracePropagationTargets: ['localhost', 'dev-octopus.playq.net', 'stg-octopus.playq.net', 'octopus.playq.net', /api\./],
    tracesSampleRate: traceRate,
    release: `${process.env.SENTRY_PROJECT_NAME}@${__CI_APP__}+${__CI_BUILD__ || localBuildId}`,
    environment: mode,
    attachStacktrace: true,
    autoSessionTracking: true,
    initialScope: {
      tags: {
        SDK: __SDK_VERSION__,
        config: __CI_CONFIG__
      }
    }
  })
}
